export default __webpack_public_path__ + "4910c8b66098f28fbb8a7694482fc64b.svg";